import React from 'react';
import { infoCardStyle, sectionHeaderStyle } from './styles';

interface LevelOverviewProps {
  level: any;
}

export const LevelOverview: React.FC<LevelOverviewProps> = ({ level }) => {
  return (
    <>
      <div style={sectionHeaderStyle}>Current Level</div>
      <div style={infoCardStyle}>
        <div style={{ fontSize: '14px', fontWeight: 'bold', color: '#3498db', marginBottom: '5px' }}>
          {level.name}
        </div>
        <div style={{ fontSize: '11px', color: '#888' }}>ID: {level.id}</div>
        <div style={{ fontSize: '11px', color: '#888' }}>
          Dimensions: {level.width} x {level.height}
        </div>
        <div style={{ fontSize: '11px', color: '#888' }}>
          Background: {level.backgroundColor}
        </div>
      </div>
    </>
  );
};
